import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMenu = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_425_2851",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 40,
		height: 40,
		children: /* @__PURE__ */ _jsx("rect", {
			width: 40,
			height: 40,
			fill: "#D9D9D9"
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0_425_2851)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M6.38887 30C5.99537 30 5.66551 29.8664 5.39929 29.5993C5.1331 29.3322 5 29.0011 5 28.6063C5 28.2114 5.1331 27.882 5.39929 27.6181C5.66551 27.3542 5.99537 27.2223 6.38887 27.2223H33.6111C34.0046 27.2223 34.3345 27.3558 34.6007 27.623C34.8669 27.8901 35 28.2211 35 28.616C35 29.0109 34.8669 29.3403 34.6007 29.6042C34.3345 29.8681 34.0046 30 33.6111 30H6.38887ZM6.38887 21.3889C5.99537 21.3889 5.66551 21.2553 5.39929 20.9882C5.1331 20.721 5 20.39 5 19.9951C5 19.6002 5.1331 19.2708 5.39929 19.007C5.66551 18.7431 5.99537 18.6111 6.38887 18.6111H33.6111C34.0046 18.6111 34.3345 18.7447 34.6007 19.0118C34.8669 19.279 35 19.61 35 20.0049C35 20.3998 34.8669 20.7292 34.6007 20.993C34.3345 21.2569 34.0046 21.3889 33.6111 21.3889H6.38887ZM6.38887 12.7778C5.99537 12.7778 5.66551 12.6442 5.39929 12.377C5.1331 12.1099 5 11.7789 5 11.384C5 10.9891 5.1331 10.6597 5.39929 10.3958C5.66551 10.1319 5.99537 10 6.38887 10H33.6111C34.0046 10 34.3345 10.1336 34.6007 10.4007C34.8669 10.6678 35 10.9989 35 11.3938C35 11.7886 34.8669 12.118 34.6007 12.3819C34.3345 12.6458 34.0046 12.7778 33.6111 12.7778H6.38887Z",
			fill: "#778521"
		})
	})]
});
export default SvgMenu;
